export default __webpack_public_path__ + "static/cardHeader-a69a1862d16e09b2d4b871cdac24826b.png";